import { useCallback, useRef, useState } from 'react'

const cancellablePromise =  (promise, onAbort, signal) => { 
    return Promise.race([
        promise(),
        new Promise((resolve) => {
                signal?.addEventListener('abort', () => {
                onAbort?.()
                resolve()
            })
        })
    ])
}


export default function useAudioController() {
    const audioRef = useRef(null)
    const [isAudioPlaying, setIsAudioPlaying] = useState(false)
    const [currentAudio, setCurrentAudio] = useState(null)
    const [audioPlaybackProgress, setAudioPlaybackProgress] = useState(0)
    let audioPromiseController;

    const playAudio = useCallback((audioUrl, onPlaybackEnd) => {
        // Stop current audio if playing
        if (audioRef.current) {
            audioRef.current.pause()
            audioRef.current.currentTime = 0
            audioRef.current.src = ''
            audioRef.current.remove()
            audioRef.current = null
        }

        // Create and play new audio
        const audio = new Audio(audioUrl)
        audio.addEventListener('ended', () => {
            setIsAudioPlaying(false)
            setCurrentAudio(null)
            if (onPlaybackEnd) {
                onPlaybackEnd()
            }
        });

        // Add progress feedback
        audio.addEventListener('loadedmetadata', () => {
            setAudioPlaybackProgress(0)
        });
        
        audio.addEventListener('timeupdate', () => {
            const percent = (audio.currentTime / audio.duration) * 100
            setAudioPlaybackProgress(percent)
        });

        audio.play();
        audioRef.current = audio;
        setIsAudioPlaying(true);
        setCurrentAudio(audioUrl);
    }, []);

    const playAudioAsync = useCallback(async (audioUrl) =>{
        audioPromiseController = new AbortController()
        await cancellablePromise(async () => {await new Promise((resolve) => {
            playAudio(audioUrl, resolve)
        })}, 
        stopAudio, 
        audioPromiseController.signal)

        console.log('playAudioAsync')
    },[])

    const stopAudioAsync = useCallback(async () => {
        if(audioPromiseController){
            audioPromiseController.abort()
            audioPromiseController = null
        }
    }, [])

    const stopAudio = useCallback(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0
            setIsAudioPlaying(false)
            setCurrentAudio(null)
            setAudioPlaybackProgress(0)
        }
    }, []);

    return {
        playAudio,
        playAudioAsync,
        stopAudio,
        stopAudioAsync,
        isAudioPlaying,
        currentAudio,
        audioPlaybackProgress
    };
};